export default [
  {
    path: "list",
    component: resolve => require(["../views/user/list.vue"], resolve)
  },
  {
    path: "list/photo/:id",
    component: resolve => require(["../views/user/photo.vue"], resolve)
  },
  {
    path: "group",
    component: resolve => require(["../views/user/group.vue"], resolve)
  },
  {
    path: "tag",
    name: "userTag",
    component: resolve => require(["../views/user/tag.vue"], resolve)
  },
  {
    path: "company",
    name: "company",
    component: resolve => require(["../views/user/company.vue"], resolve)
  },
  {
    path: "tagEdit/:tagId",
    name: "userTagEdit",
    component: resolve => require(["../views/user/tagEdit.vue"], resolve)
  },
  {
    path: "approval",
    component: resolve => require(["../views/user/approval.vue"], resolve)
  }
];
